package eu.bontlab.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Width
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.modifiers.title
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import eu.bontlab.models.PortfolioItem
import eu.bontlab.models.Theme
import eu.bontlab.sections.AppImage
import eu.bontlab.styles.MainImageStyle
import eu.bontlab.styles.PortfolioSectionStyle
import eu.bontlab.util.Constants.FONT_FAMILY
import eu.bontlab.util.Res
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun PortfolioCard(
    breakpoint: Breakpoint,
    modifier: Modifier = Modifier,
    portfolio: PortfolioItem,
    link: String = ""// WEBSITE
) {

/*    Link(
        modifier = PortfolioSectionStyle.toModifier()
            .textDecorationLine(TextDecorationLine.None),
        path = link,
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) { */
        Column(
            modifier = modifier
                .id("columnParent")
                .fillMaxWidth()
                .fillMaxHeight()
                .maxWidth(300.px)
        ) {
            /* Box(
                modifier = Modifier
                    .id("boxParent")
                    .fillMaxWidth()
                    .maxWidth(300.px)
                    .margin(bottom = 20.px)
            ) { */
            // Column(
            /*     modifier = Modifier
                        .fillMaxSize(60.percent)
                        .fillMaxHeight()
                        .padding (bottom = 20.px),
                    verticalArrangement = Arrangement.Bottom
                ) {  */
            /*     modifier = Modifier
                        .fillMaxHeight()
                        .maxWidth(300.px)
               ) { */

            Image(
                modifier = Modifier
                    .fillMaxHeight()
                    .maxWidth(300.px),
                //    .width((300.px))
                //   .size(300.px)
                //.objectFit(ObjectFit.Cover),
                src = portfolio.image,
                alt = "Portfolio Image"
            )

            P(
                attrs = Modifier
                    .id("portfolioTitle")
                    .fillMaxWidth()
                    .margin(top = 40.px, bottom = 0.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(18.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Theme.Secondary.rgb)
                    .toAttrs()
            ) {
                Text(portfolio.title)
            }
            P(
                attrs = Modifier
                    .id("portfolioDesc")
                    .fillMaxWidth()
                    .margin(topBottom = 0.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(14.px)
                    .fontWeight(FontWeight.Normal)
                    .color(Theme.LightGray.rgb)
                   // .opacity(50.percent)
                    .toAttrs()
            ) {
                Text(portfolio.description)
            }
            // }

            /*
                Image(
                    modifier = Modifier
                       .fillMaxWidth(),
                      //  .fillMaxHeight()
                      //  .width((300.px))
                       // .size(300.px)
                     //   .objectFit(ObjectFit.Cover),
                    src = portfolio.image,
                    alt = "Portfolio Image"
                ) } */
            /*       Box(
                    modifier = Modifier
                        .id("greenOverlay")
                        .fillMaxHeight()
                   //     .backgroundColor(argb(a = 0.5f, r = 0, g = 167, b = 142)),
                        .backgroundColor(argb(a = 0.0f, r = 0, g = 167, b = 142)),
                    contentAlignment = Alignment.Center
                ) {
                    Image(
                        modifier = Modifier
                            .id("linkIcon")
                            .size(32.px),
                        src = Res.Icon.link,
                        alt = "Link Icon"
                    )
                } */
            //  }

        }
    }
//}


@Composable
fun AppImage(image_id: String) {
    Column(
        modifier = Modifier
            .fillMaxSize(60.percent)
            .fillMaxHeight()
            .padding (bottom = 30.px),
        verticalArrangement = Arrangement.Bottom
    ) {

        Image(
            modifier = MainImageStyle.toModifier()
                .fillMaxWidth(),
            src = image_id,
            alt = "Main Image"
        )

    }
}